module.exports = __webpack_public_path__ + "static/media/lamp-desk.6995d4e4.svg";